import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const MedAmountForm = (props) => {

  const initialFormData = {
    amount: "",
    //medvalue: " ", //need to change after the API Call
    isactive: true,
    id: ""
  };

  const [formData, setFormData] = useState(initialFormData);
  const formRef = useRef(null);
  const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
  //const navigate = useNavigate();

  useEffect(() => {
    if (props.medamtvalue && (props.medamtvalue.medamount_id || props.medamtvalue.amount_id || props.medamtvalue.id)) {
      const { amount, is_active, medamount_id, amount_id, id } = props.medamtvalue;
      setFormData({
        amount: amount || "",
        isactive: is_active == 1 || is_active === true,
        id: medamount_id || amount_id || id || ""
      });
      setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
    } else {
      setFormData(initialFormData);
      setButtonStatus(mapYourMedsConstant.ADD_ACTION);
    }
  }, [props.edittrigger, props.medamtvalue]);


  const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

  const handleSubmit = async e => {
    e.preventDefault();

    let tokenStr = localStorage.getItem("accessToken");
    let pelmedsMedsAmountUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/drugs/add-drug-amount` : `${process.env.REACT_APP_SERVER_URL}/drugs/update-drug-amount`;
    let pelmedsMedsAmountData = isAddMode ? 
      { "amount": formData.amount, "group_id": localStorage.getItem("groupId") || '', "is_active": 1 } :
      { "amount": formData.amount, "group_id": localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id };

    const { data } = await axios.post(pelmedsMedsAmountUrl, pelmedsMedsAmountData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

    if (data.status) {
      toast.success("Meds Amount added/updated successfully");
    }
    else {
      toast.info("Error while adding Meds Amount");
    }

    setFormData(initialFormData);
    formRef.current.reset();
    setButtonStatus("Add");

    props.onCallParent();
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form ref={formRef} onSubmit={handleSubmit}>
      <Row>
        <Col xs={4}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Amount</Form.Label>
            <Form.Control
              placeholder='Amount'
              value={formData.amount}
              name="amount"
              size="sm"
              onChange={handleFieldChange}
              type="text"
            />
          </Form.Group>
        </Col>
        <Col xs={4}>
          <Form.Group>
            <Button
              type="submit"
              color="primary"
              className="mt-4 w-50"
              size="sm"
              disabled={!formData.amount}>
              {buttonStatus}
            </Button>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Form.Group>
            <Form.Check
              type='switch'
              name="isactive"
              id='isactive'
              checked={isAddMode ? true : formData.isactive}
              disabled={isAddMode}
              onChange={e =>
                setFormData({
                  ...formData,
                  isactive: e.target.checked
                })
              }
              label='Active'
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
        </Col>
      </Row>
    </Form>
  );
};
export default MedAmountForm;

